import '../../assets/css/login.css';
import React from 'react';
import Button from 'components/CustomButtons/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { FaSpinner } from 'react-icons/fa';
import { Redirect } from 'react-router-dom';
import hcfamemalogo from '../../assets/img/hcfamemalogo.png';
import { dominioDemandaCirurgica } from '../../config/database';

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function Login() {
  const classes = useStyles();
  const [redireciona, setRedireciona] = React.useState(false);
  const [snackPack, setSnackPack] = React.useState([]);
  const [messageInfo, setMessageInfo] = React.useState(undefined);
  const [messagemErro, setMessagemErro] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const profissionalStorage = localStorage.getItem('profissional');
    if (profissionalStorage) setRedireciona(true);
  }, []);

  React.useEffect(() => {
    if (snackPack.length && !messageInfo) {
      setSnackPack(prev => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      setOpen(false);
    }
  }, [snackPack, messageInfo, open, messagemErro]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleExited = () => {
    setMessageInfo(undefined);
  };

  const getConfiguracoesRecursoSistema = () => {
    dominioDemandaCirurgica.get('/api/configuracoesRecursoSistema').then(
      res => {
        localStorage.setItem('configuracoesRecursoSistema', JSON.stringify(res.data));
      },
      () => {
        const msg = 'Falha ao recuperar as configurações de recursos do sistema';
        setLoading(false);
        setMessagemErro(msg);
        setOpen(true);
      }
    );
  };

  const getConfiguracoes = () => {
    dominioDemandaCirurgica
      .get('/api/configuracoes')
      .then(
        res => {
          localStorage.setItem('configuracoes', JSON.stringify(res.data));
          getConfiguracoesRecursoSistema();
        },
        () => {
          const msg = 'Falha ao recuperar as configurações do sistema';
          setLoading(false);
          setMessagemErro(msg);
          setOpen(true);
        }
      )
      .then(() => {
        setRedireciona(true);
      });
  };

  const handleSubmit = e => {
    e.preventDefault();

    setLoading(true);

    const username = document.getElementById('username').value;
    const password = document.getElementById('password').value;

    const data = {
      username,
      password,
    };

    dominioDemandaCirurgica.post('/api/loginDemanda', data).then(
      res => {
        localStorage.setItem('profissional', JSON.stringify(res.data));
        getConfiguracoes();
      },
      () => {
        const msg = 'Não foi possível fazer login com as credenciais informadas.';
        setLoading(false);
        setMessagemErro(msg);
        setOpen(true);
      }
    );
  };

  if (redireciona) return <Redirect from="/" to="/admin/meusPedidos" />;

  return (
    <Container component="main" maxWidth="xs">
      <Snackbar
        className="shackbar-interno"
        key={messageInfo ? messageInfo.key : undefined}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        open={open}
        autoHideDuration={4000}
        onClose={handleClose}
        onExited={handleExited}
        message={messagemErro}
        action={
          <>
            <IconButton
              aria-label="close"
              color="inherit"
              className={classes.close}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </>
        }
      />
      <CssBaseline />
      <div className={classes.paper}>
        <img alt="logo" src={hcfamemalogo} />
        <form className={classes.form} onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Usuário"
            name="username"
            autoComplete="email"
            autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Senha"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="info"
            className={classes.submit}
          >
            {loading ? <FaSpinner /> : <> Entrar </>}
          </Button>
        </form>
      </div>
    </Container>
  );
}
